import { CampsiteReviewFilterOption } from './review-filter-options/domain'
import { FilterCounts } from './types'

interface GroupedOption {
  [key: string]: {
    [key: string]: {
      option: CampsiteReviewFilterOption
      count: number
    }
  }
}

class ReviewFilterOptionsGrouper {
  private options: CampsiteReviewFilterOption[]
  private grouped: GroupedOption

  constructor(options: CampsiteReviewFilterOption[]) {
    this.options = options
    this.grouped = this.options.reduce(this.reviewFilterGroupReducer, {})
  }

  getCounted(counts: FilterCounts) {
    const groupByType = { ...this.grouped }
    for (const [type, options] of Object.entries(groupByType)) {
      const typeCounts = counts[type]
      for (const optionKey of Object.keys(options)) {
        const count = typeCounts[optionKey]
        if (count) {
          groupByType[type][optionKey].count = count
        }
      }
    }
    return groupByType
  }

  private reviewFilterGroupReducer(
    grouped: GroupedOption,
    option: CampsiteReviewFilterOption,
  ) {
    if (!grouped.hasOwnProperty(option.type)) {
      grouped[option.type] = {}
    }
    if (option.name) {
      grouped[option.type][option.name] = { option, count: 0 }
    }
    return grouped
  }
}

export default ReviewFilterOptionsGrouper
